'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var form = $('[data-binding="pow-form"]');
    var ajaxAction = form.attr('action');
    var selected = [];

    function openPopup() {
        context.find('[data-binding="popup"]').addClass('open');
    }

    function closePopup() {
        context.find('[data-binding="popup"]').removeClass('open');
    }

    function countPicks() {
        return selected.length;
    }

    function picksAvailable() {
        var picksleft = 8 - countPicks(),
            overlaytitletxt = 'You have ' + picksleft + ' picks remaining',
            $overlayTitle = context.find('[data-binding="title"]');

        $overlayTitle.html('');
        $overlayTitle.html(overlaytitletxt);
    }

    function refreshResults(reset) {
        $.ajax({
            type: 'post',
            url: ajaxAction,
            data: form.serialize(),
            success: function success(data) {
                context.find('[data-binding="search-results"]').html(data);
                if (reset === 'noreset') {} else {
                    picksAvailable();
                }
            },
            error: function error(xhr, status) {
                alert(status);
            }
        });
        if (reset === 'noreset') {} else {
            selected = [];
        }
    }

    function addToArray(id) {
        selected.push(id);
        picksAvailable();
    }

    function removeFromArray(id) {
        var index = selected.indexOf(id);
        if (index > -1) {
            selected.splice(index, 1);
        }
        picksAvailable();
    }

    function addPick(ids) {
        var ajaxAction = form.attr('action');

        $.ajax({
            type: 'post',
            url: ajaxAction + '/Add',
            data: { ids: ids },
            success: function success(data) {
                $('[data-binding="current-picks"]').html(data);
                refreshResults();
            },
            error: function error(xhr, status, response) {
                alert(response);
            }
        });
    }

    function removePick(id) {
        $.ajax({
            type: 'post',
            url: ajaxAction + '/Remove',
            data: { id: id },
            success: function success(data) {
                $('[data-binding="current-picks"]').html(data);
                refreshResults();
            },
            error: function error(xhr, status, response) {
                alert(response);
            }
        });
    }

    function loadviewoverlay(url, pickId, title) {
        var html = '<div class="pick-of-the-week__overlay open vacancy" data-binding="popupview">' + '<div class="pick-of-the-week__overlay__content">' + '<div class="pick-of-the-week__overlay__header">' + '<h3 class="pick-of-the-week__overlay__heading" data-binding="title">' + title + '</h3>' + '<button class="pick-of-the-week__overlay__close" data-binding="closeview">X</button>' + '</div>' + '<iframe class="pick-of-the-week__overlay__content__iframe" src="' + url + '"></iframe>' + '<div class="pick-of-the-week__overlay__footer" data-binding="viewoverlayfooter">' + '</div></div>',
            buttonhtml = '<button class="pick-of-the-week__overlay__footer__button" data-id="' + pickId + '" data-binding="popuppreselect">Submit as pick</button>' + '<button class="pick-of-the-week__overlay__footer__button-cancel" data-binding="closeview">Cancel</button>';

        context.find('[data-binding="popup"]').after(html);
        if (countPicks() >= 8) {
            context.find('[data-binding="viewoverlayfooter"]').html('<p>Selection limit reached. Deselect another item to select this one</p>');
        } else {
            context.find('[data-binding="viewoverlayfooter"]').html(buttonhtml);
        }
        context.on('click', '[data-binding="closeview"]', function (e) {
            e.preventDefault();
            $(this).closest('[data-binding="popupview"]').remove();
        });
    }

    function closeItemMenu() {
        context.find('[data-binding="menutoggle"]').removeClass('active');
        context.find('[data-binding="itemmenu"]').removeClass('active');
    }

    function init() {

        form.addClass('jsactive');

        picksAvailable();

        context.on('click', '[data-binding="menutoggle"]', function (e) {
            e.preventDefault();

            if ($(this).hasClass('active')) {
                closeItemMenu();
            } else {
                closeItemMenu();
                $(this).addClass('active');
                $(this).next('[data-binding="itemmenu"]').addClass('active');
            }
        });

        context.on('click', '[data-binding="submit-selection"]', function (e) {
            e.preventDefault();
            addPick(selected);
            closePopup();
        });

        context.on('click', '[data-binding="openpopup"]', function (e) {
            e.preventDefault();
            openPopup();
            closeItemMenu();
        });

        context.on('click', '[data-binding="preselect"]', function (e) {
            e.preventDefault();

            if ($(this).hasClass('checked')) {
                $(this).removeClass('checked');
                context.find('[data-binding="error"]').remove();
                removeFromArray($(this).data('id'));
            } else {
                if (countPicks() >= 8) {
                    if (!context.find('.pick-of-the-week__overlay__header__error').length) {
                        context.find('.pick-of-the-week__overlay__header').append('<p class="pick-of-the-week__overlay__header__error" data-binding="error">You can only select 8 picks. Deselect one to add more.</p>');
                    }
                } else {
                    $(this).addClass('checked');
                    addToArray($(this).data('id'));
                }
            }
        });

        context.on('click', '[data-binding="popuppreselect"]', function (e) {
            var itemid = $(this).data('id');

            e.preventDefault();

            if (selected.indexOf(itemid) >= 0) {
                context.find('.pick-of-the-week__results__item__button[data-id="' + itemid + '"]').removeClass('checked');
                removeFromArray(itemid);
            } else {
                context.find('.pick-of-the-week__results__item__button[data-id="' + itemid + '"]').addClass('checked');
                addToArray(itemid);
            }

            context.find('[data-binding="popupview"]').remove();
        });

        context.on('click', '[data-binding="removeitem"]', function (e) {
            e.preventDefault();
            removePick($(this).data('id'));
        });

        context.on('click', '[data-binding="viewpage"]', function (e) {
            e.preventDefault();
            loadviewoverlay($(this).attr('href'), $(this).data('id'), $(this).data('title'));
        });

        context.on('click', '[data-binding="close"]', function () {
            closePopup();
        });

        //reload on search submit
        context.find('[data-binding="pow-form"]').on('submit', function (e) {
            e.preventDefault();
            refreshResults('noreset');
        });

        //reload results on paging change
        context.on('click', '.pagination__link', function (e) {
            e.preventDefault();

            context.find('[data-binding="page-number"]').val(parseInt($(this).attr('href').split('=')[1]));
            refreshResults('noreset');
            $('[data-binding="scrollingcontainer"]').scrollTop(0);
        });
    }

    return {

        init: init

    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/pick-of-the-week.js
// module id = 485
// module chunks = 0